import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatMessage, FormattedMessage } from 'translate';
import Tooltip from 'rc-tooltip';

import { copyToBuffer } from '../../2key_modules/utils';

const CopyWrap = styled.div`
  position: relative;
  background-color: transparent;
  border: none;
  cursor: pointer;
  &:focus {
    outline: none
  }
  &[disabled] {
    opacity: 0.4;
    cursor: default;
  }
`;

class CopyToClipboard extends React.PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.node]),
    className: PropTypes.string,
    disabled: PropTypes.bool,
    timeout: PropTypes.number,
    value: PropTypes.string.isRequired,
  }

  static defaultProps = {
    children: <FormattedMessage id="main.copy_to_clipboard" />,
    timeout: 2000,
  }

  state = {
    timeoutId: null,
  }

  componentWillUnmount() {
    const { timeoutId } = this.state;
    clearTimeout(timeoutId);
  }

  handleClick = () => {
    const { value, timeout } = this.props;
    const timeoutId = setTimeout(() => this.setState({ timeoutId: null }), timeout);

    copyToBuffer(value);
    this.setState({ timeoutId });
  }
  render() {
    const { timeoutId } = this.state;
    const { className, children, disabled } = this.props;

    return (
      <Tooltip
        animation="zoom"
        overlayClassName="twokey-tooltip-wrap"
        visible={!!timeoutId}
        placement="top"
        overlay={<FormattedMessage id="main.copied_to_clipboard" />}
      >
        <CopyWrap
          className={className}
          disabled={disabled}
          onClick={this.handleClick}
          title={formatMessage({ id: 'main.copy_to_clipboard' })}
        >
          {children}
        </CopyWrap>
      </Tooltip>
    );
  }
}

export default CopyToClipboard;
